/**
 * API Endpoints Constants
 * Centralized API endpoint definitions
 */

export const API_ENDPOINTS = {
	// Auth
	AUTH: {
		LOGIN: 'transporters/store-login',
		ME: 'users/me',
	},

	// Orders
	ORDERS: {
		BASE: 'orders',
		BY_ID: (id: number | string) => `orders/${id}`,
	},

	// Stores
	STORES: {
		BASE: 'stores',
		BY_ID: (id: number | string) => `stores/${id}`,
		REGISTRATION: 'transporters/store-registration',
	},

	// Distributors
	DISTRIBUTORS: {
		BASE: 'distributors',
		BY_ID: (id: number | string) => `distributors/${id}`,
		CASHIER: 'transporters/distributor-cashier',
		EARNINGS: 'transporters/distributor-earnings',
		SHIFTS: 'transporters/distributor-shifts',
	},

	// Customers
	CUSTOMERS: {
		BASE: 'customers',
		BY_ID: (id: number | string) => `customers/${id}`,
	},

	// Addresses
	ADDRESSES: {
		BASE: 'addresses',
		BY_ID: (id: number | string) => `addresses/${id}`,
		CATEGORIES: 'address-categories',
	},

	// Transporters specific
	TRANSPORTERS: {
		NOTIFY_DISTRIBUTOR: 'transporters/notifyDistributorOrder',
		CHAT_USERS: 'transporters/getChatUsers',
		SYSTEM_STATUS: 'transporters/system-status',
		WORKLOAD: 'transporters/workload',
		SHIFT_MANAGER: 'transporters/shift-manager',
	},
} as const

